import { authActions } from "./actions";

const initState = {
  user: null,
  selectedUser: null,
  organisation: null,
  businessUnit: { _id: "ALL", name: "All Teams" },
  app: null,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case authActions.SETUSER:
      return { ...state, user: action.user };
    case authActions.SETSELECTEDUSER:
      return { ...state, selectedUser: action.selectedUser };
    case authActions.SETORGANISATION:
      return { ...state, organisation: action.organisation };
    case authActions.SETBUSINESSUNIT:
      return { ...state, businessUnit: action.businessUnit };
    case authActions.SETAPP:
      return { ...state, app: action.app };
    default:
      return state;
  }
}
